import { ManagedStep } from "common/components/StepContainer";
import React from "react";
import { useTransferSelectPrepInstructions } from "./hooks/useTransferSelectPrepInstructions";
import { PrepInstructions } from "prep/create/PrepInstructions/PrepInstructions";

export const TransferSelectPrepInstructions = () => {
  const {
    isLoading,
    isCoverLabelsChecked,
    handleCoverLabelsChange,
    handleLabelSelect,
    labelPlacement,
    labelPlacementOptions,
  } = useTransferSelectPrepInstructions();

  return (
    <ManagedStep data-testid="transfers-select-prep-instructions" isLoading={isLoading}>
      <PrepInstructions
        isCoverLabelsChecked={isCoverLabelsChecked}
        handleCoverLabelsChange={handleCoverLabelsChange}
        handleLabelSelect={handleLabelSelect}
        labelPlacement={labelPlacement}
        labelPlacementOptions={labelPlacementOptions}
      />
    </ManagedStep>
  );
};
